// extracted by mini-css-extract-plugin
export default {"value":"CalculationInput_value__g-BS4","wrapper":"CalculationInput_wrapper__LqtwG"};